module.exports = __webpack_public_path__ + "0ff42577079a2bdd2066bf660fb50ffc.svg";